import { getGlobalCssUrl, getComponentCssUrl } from '../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createFormControlMessagingTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl('')}" rel="stylesheet" />
<link href="${getComponentCssUrl('FormControlMessaging--wc.css')}" rel="stylesheet" />
`
  return t
}

const getTemplateFormControlMessagingStyles = () => createFormControlMessagingTemplate()
export { getTemplateFormControlMessagingStyles }
